import { Link } from "react-router-dom";
import { services } from "@/mocks/services";

export default function ServiceEntry() {
  return (
    <section className="bg-secondary-50 py-14 md:py-20">
      <div className="container-site">
        <div className="text-center max-w-2xl mx-auto">
          <span className="text-xs font-semibold tracking-[0.25em] uppercase text-primary-700">
            Our Services
          </span>
          <h2 className="font-heading font-extrabold text-2xl md:text-4xl text-foreground-950 mt-3">
            三大核心业务，覆盖内容全链路
          </h2>
          <p className="text-foreground-600 mt-4 text-sm md:text-base">
            从创意发想到成片发行，芒果传媒提供一体化的影视传媒服务能力。
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mt-12">
          {services.map((s) => (
            <Link
              key={s.id}
              to={`/services#${s.anchor}`}
              className="group bg-background-50 rounded-lg p-6 md:p-7 border border-background-200/80 hover:border-primary-300 transition-all cursor-pointer flex flex-col"
            >
              <span className="w-14 h-14 md:w-16 md:h-16 rounded-lg bg-primary-100 flex items-center justify-center group-hover:bg-primary-500 transition-colors">
                <i className={`${s.icon} text-3xl text-primary-700 group-hover:text-foreground-950 transition-colors`}></i>
              </span>
              <h3 className="font-heading font-bold text-lg md:text-xl text-foreground-950 mt-5">
                {s.title}
              </h3>
              <p className="text-sm text-foreground-600 mt-2 leading-relaxed flex-1">
                {s.tagline}
              </p>
              <span className="inline-flex items-center gap-1.5 text-sm font-semibold text-primary-700 mt-5 group-hover:gap-3 transition-all">
                了解更多
                <i className="ri-arrow-right-line"></i>
              </span>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}